import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import React from 'react';
import styled from 'styled-components';
import { Box, Link, Text, useBreakpoint, Flex, Popover, InfoFilled, Group } from '@landr/maestro';
import { openNetworkLink } from '@landr/core';
import { palette } from '@landr/maestro-legacy';
import { useProfileTooltipContent } from './hooks/useProfileTooltipContent.es.js';
import { useNavBarContext } from '../../../../../../../contexts/NavBarProvider/NavBarContext.es.js';

var _templateObject, _templateObject2, _templateObject3;
var StyledInfoIcon = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    cursor: pointer;\n"])));
var StyledInvertedLink = styled(Link)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    text-decoration: none;\n    &:hover {\n        text-decoration: underline;\n    }\n    color: ", ";\n"])), palette('primary.500'));
var UnBreakText = styled(Text)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    word-break: keep-all;\n"])));
var ProfileTooltip = function ProfileTooltip() {
  var tooltipContent = useProfileTooltipContent();
  var _useNavBarContext = useNavBarContext(),
    env = _useNavBarContext.env;
  var isMobile = useBreakpoint('md');
  var isTablet = useBreakpoint('lg');
  if (!tooltipContent) {
    return null;
  }
  var header = tooltipContent.header,
    body = tooltipContent.body,
    footer = tooltipContent.footer;
  var handleOnNavigateToProfile = function handleOnNavigateToProfile() {
    return openNetworkLink(env, '/users/me/edit/general-info');
  };
  return /*#__PURE__*/React.createElement(Flex, {
    onClick: function onClick(event) {
      if (isTablet) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, /*#__PURE__*/React.createElement(Popover, {
    usePortal: false,
    placement: "bottom-end",
    triggerEvent: isTablet ? 'click' : 'hover'
  }, function (_ref) {
    var close = _ref.close;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popover.Trigger, null, /*#__PURE__*/React.createElement(StyledInfoIcon, null, /*#__PURE__*/React.createElement(InfoFilled, {
      size: "sm"
    }))), /*#__PURE__*/React.createElement(Popover.Content, {
      pb: "lg"
    }, /*#__PURE__*/React.createElement(Group, {
      direction: "vertical",
      gutter: "xs",
      alignItems: "center",
      onClick: close
    }, /*#__PURE__*/React.createElement(Group.Item, {
      paddingX: "xxs",
      pt: "sm",
      pb: "xs"
    }, /*#__PURE__*/React.createElement(Flex, {
      flexDirection: "column",
      width: isMobile ? '100%' : '320px'
    }, /*#__PURE__*/React.createElement(Text, {
      fontWeight: "bold"
    }, header), /*#__PURE__*/React.createElement(UnBreakText, {
      contrast: "low"
    }, body))), /*#__PURE__*/React.createElement(Group.Item, {
      width: "100%"
    }, /*#__PURE__*/React.createElement(StyledInvertedLink, {
      isFull: true,
      onClick: handleOnNavigateToProfile
    }, footer)))));
  }));
};

export { ProfileTooltip };
